import React from 'react';
import Typography from '@mui/material/Typography';

function ContentComponent(props) {
	return <Typography className="pb-24" dangerouslySetInnerHTML={{ __html: props.data.replaceAll('\\n', '</br>') }} />;
}

export default ContentComponent;
